var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { PreventionCourseFullSizeDto } from '../prevention-courses/dtos/prevention-course.full-size.dto.js';
import { UserProfileDto } from '../user/index.js';
import { ConnectedStripeAccountFullSizeDto } from './dto/connected-stripe-account.full-size.dto.js';
import { PaymentTarget } from './payment-target.enum.js';
import { PaymentType } from './payment-type.enum.js';
export class PaymentFullSizeDto {
    id;
    createdAt;
    updatedAt;
    target;
    officeProductId;
    type;
    preventionCourseId;
    preventionCourse;
    userId;
    user;
    stripeCheckoutSessionId;
    stripePaymentIntentId;
    preventionVoucherId;
    connectedStripeAccountId;
    connectedStripeAccount;
    stripeAccountId;
    rawData;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PaymentFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], PaymentFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], PaymentFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsEnum(PaymentTarget),
    __metadata("design:type", String)
], PaymentFullSizeDto.prototype, "target", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "officeProductId", void 0);
__decorate([
    Expose(),
    IsEnum(PaymentType),
    __metadata("design:type", String)
], PaymentFullSizeDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "preventionCourseId", void 0);
__decorate([
    IsObject(),
    Type(() => PreventionCourseFullSizeDto),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "preventionCourse", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PaymentFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Function)
], PaymentFullSizeDto.prototype, "user", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "stripeCheckoutSessionId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "stripePaymentIntentId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "preventionVoucherId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    IsOptional(),
    Type(() => ConnectedStripeAccountFullSizeDto),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "connectedStripeAccount", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "stripeAccountId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PaymentFullSizeDto.prototype, "rawData", void 0);
//# sourceMappingURL=payment.full-size.dto.js.map